import React from "react";
import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

type IconWithBackgroundProps = {
  icon: IconDefinition;
  className?: string;
  backgroundClassName?: string;
  borderRadius?: string;
  bigPadding?: boolean;
  size?: FontAwesomeIconProps["size"];
} & Omit<FontAwesomeIconProps, "icon" | "className" | "size">;

const IconWithBackground: React.FC<IconWithBackgroundProps> = ({
  icon,
  className = "",
  backgroundClassName = "",
  borderRadius = "rounded-full",
  bigPadding,
  size,
  ...fontAwesomeProps
}) => {
  const paddingClass = bigPadding ? "p-2" : "p-0.5";
  const hasCustomBg = backgroundClassName?.includes("bg-");
  const defaultBackgroundClasses = hasCustomBg ? "" : "bg-white";

  return (
    <div
      className={`relative inline-flex items-center justify-center ${borderRadius} ${paddingClass} ${defaultBackgroundClasses} ${backgroundClassName}`}
    >
      <FontAwesomeIcon
        icon={icon}
        size={size}
        className={className}
        {...fontAwesomeProps}
      />
    </div>
  );
};

export default IconWithBackground;